import React, { useState, useEffect } from "react";

type InlineTabProps = {
  defaultTabIndex?: number;
  lazy?: boolean;
  tabIndex?: number | any;
  onTabChange?: (v: number) => void;
  children: React.ReactElement<InlineTabContentProps>[];
};

type InlineTabContentProps = {
  children: JSX.Element[] | JSX.Element;
  alias?: string;
  name: string;
};

export function InlineTab(props: InlineTabProps) {
  const [selectedIndex, setSelectedIndex] = useState(
    props.defaultTabIndex || 0
  );

  const [loadedTabs] = useState(
    new Array(props.children.length).fill(props.lazy === true ? false : true)
  );

  // Listen for the tabIndex change
  useEffect(() => {
    if (props.tabIndex !== undefined) {
      changeTabIndex(props.tabIndex);
    }
  });

  const children: React.ReactElement<
    InlineTabContentProps
  >[] = props.children as React.ReactElement<InlineTabContentProps>[];

  function changeTabIndex(index: number) {
    setSelectedIndex(index);
    (window as any).location.hash = children[index].props.alias;
  }

  // Render Header
  const childrenHeader = children.map((x, index) => {
    let tabHeaderClassName = "step-trigger";
    if (x.props.alias === "") {
      tabHeaderClassName += " active complete";
    } else if (index === selectedIndex) {
      tabHeaderClassName += " active complete";
    }

    return (
      <div
        key={x.props.name}
        className={tabHeaderClassName}
        onClick={() => {
          if (props.tabIndex === undefined) {
            changeTabIndex(index);
          } else if (props.onTabChange) {
            props.onTabChange(index);
          }
        }}
      >
        {x.props.name}
      </div>
    );
  });

  // Render Content
  const childrenContent = children.map((x, index) => {
    if (!loadedTabs[index]) return <div key={x.props.name}></div>;
    return (
      <div
        key={x.props.name}
        className={selectedIndex === index ? "" : "d-none"}
      >
        {children[index]}
      </div>
    );
  });

  return (
    <div>
      <div className="step-triggers">{childrenHeader}</div>
      <div>{childrenContent}</div>
    </div>
  );
}

export function InlineTabContent(props: InlineTabContentProps) {
  return <>{props.children}</>;
}
